import React from 'react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined, LinkOutlined } from '@ant-design/icons';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import { ResultType } from '../../../types/banner';

interface MediaActionsProps {
  src: string;
  type: ResultType;
  isHovered: boolean;
}

const getFileName = (src: string): string => {
  const urlParts = src.split('/');
  const filename = urlParts[urlParts.length - 1].split('?')[0];
  return filename;
};

export const MediaActions: React.FC<MediaActionsProps> = ({ src, type, isHovered }) => {
  const { screens, fontSize } = useResponsiveSizes();
  const [hoveredBtn, setHoveredBtn] = React.useState<string | null>(null);
  const buttonSize = screens.xs ? 20 : screens.md ? 30 : 40;

  const handleDownload = () => {
    const filename = getFileName(src);
    const link = document.createElement('a');
    link.href = src;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(src);
  };

  const getButtonStyle = (btnId: string): React.CSSProperties => ({
    width: buttonSize,
    height: buttonSize,
    borderRadius: '50%',
    background: hoveredBtn === btnId ? '#667eea' : 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: hoveredBtn === btnId ? 'white' : '#667eea',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.2s ease',
    transform: isHovered ? 'translateY(0)' : 'translateY(10px)',
    outline: 'none'
  });

  return (
    <>
      <Tooltip title='Copiar enlace' styles={{ body: { fontSize: fontSize.sm } }}>
        <Button
          onClick={handleCopyUrl}
          icon={<LinkOutlined />}
          onMouseEnter={() => setHoveredBtn('copy')}
          onMouseLeave={() => setHoveredBtn(null)}
          style={getButtonStyle('copy')}
        />
      </Tooltip>

      <Tooltip title='Descargar' styles={{ body: { fontSize: fontSize.sm } }}>
        <Button
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          onMouseEnter={() => setHoveredBtn('download')}
          onMouseLeave={() => setHoveredBtn(null)}
          style={getButtonStyle('download')}
        />
      </Tooltip>
    </>
  );
};
